export default __webpack_public_path__ + "static/media/fla.fb729ca2.svg";